import { configureStore } from '@reduxjs/toolkit';
import { debounce } from "../helpers/helpers";
import authReducer from './authSlice';
import { loadState, saveState } from './browser-storage';
import headquarterProfileReducer from './headquarterProfileSlice';
import pickupProfileReducer from './pickupProfileSlice';
import productProfileReducer from './productProfileSlice';
import providerInvoiceProfileReducer from './providerInvoiceProfileSlice';
import providerProfileReducer from './providerProfileSlice';
import routeProfileReducer from './routeProfileSlice';
import sidebarSliceReducer from './sidebarSlice';
import statesReducer from './statesSlice';
import tableReducer from './tableSlice';
import userProfileReducer from './userProfileSlice';
import clientProfileReducer from './clientProfileSlice';
import invoiceProfileReducer from './invoiceProfileSlice';

const store = configureStore({
  reducer: {
    //@ts-ignore
    auth: authReducer,
    table: tableReducer,
    userProfile: userProfileReducer,
    productProfile: productProfileReducer,
    statesProfile: statesReducer,
    sidebarSlice: sidebarSliceReducer,
    providerProfile: providerProfileReducer,
    providerInvoiceProfile: providerInvoiceProfileReducer,
    headquarterProfile: headquarterProfileReducer,
    pickupProfile: pickupProfileReducer,
    clientProfile: clientProfileReducer,
    invoiceProfile: invoiceProfileReducer,
    routeProfile: routeProfileReducer
  },
  preloadedState: loadState(),
});

// here we subscribe to the store changes
store.subscribe(
  // we use debounce to save the state once each 800ms
  // for better performances in case multiple changes occur in a short time
  debounce(() => {
    saveState(store.getState());
  }, 800));

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export default store;